// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import React, { useEffect, useState } from 'react';
import { Box, Divider, Typography, useTheme } from '@mui/material';
import { useParams } from 'react-router-dom';
import LoadingSpinner from 'Components/LoadingSpinner';
import SearchField from 'Components/SearchField';
import { useAppDispatch, useAppSelector } from 'Hooks';
import { RootState } from 'Store';
import orderListIcon from 'Assets/order_list_icon.png';
import { GetOrderAdjustmentsThunk, GetOrgThunk } from '../adminThunk';
import { SetOrgIdAction } from '../adminActions';
import OrderAdjustmentCard from './orderAdjustmentCard';
import stylesDef from './styles';

const OrderAdjustments: React.FC = () => {
  // Constants
  const theme = useTheme();
  const styles = stylesDef(theme);
  const dispatch = useAppDispatch();
  const { orgId } = useParams();
  const orderAdjustmentsDetails = useAppSelector((state: RootState) => state.admin.orderAdjustmentsDetails);

  // State Variables
  const [showLoader, setShowLoader] = useState(false);

  //useEffects
  useEffect(() => {
    loadData();
  }, []);

  //Methods
  const loadData = async (searchQuery?: string) => {
    setShowLoader(true);
    if (_ADMIN_) {
      await Promise.all([
        dispatch(GetOrgThunk(orgId)),
        dispatch(SetOrgIdAction(orgId))
      ]);
    } 
    await dispatch(GetOrderAdjustmentsThunk(searchQuery));
    setShowLoader(false);
  };

  return (
    <LoadingSpinner loading={showLoader}>
      <Box sx={styles.pageWrapper}>
        <Box sx={styles.itemsWrapper}>
            <SearchField
              sx={styles.icons}
              placeholder="Search"
              debounceTimeout={500}
              onChange={(value) => loadData(value)}
            />
          </Box>
          <Divider sx={styles.divider} />
          {!showLoader && orderAdjustmentsDetails.length > 0 ? orderAdjustmentsDetails?.map((item) => (
            <OrderAdjustmentCard key={item.projectId} orderAdjustment={item} />
          )) : (
            <Box sx={styles.noOrderContainer}>
              <img src={orderListIcon} alt="icon" />
              <Typography variant="h5">No Order Adjustments available</Typography>
            </Box>
          )}
      </Box>
    </LoadingSpinner>
  );
};

export default OrderAdjustments;
